<span class="switch" [class.checked]="checked" [class.disabled]="disabled" [class.switch-large]="size === 'large'">
    <input type="checkbox" id="enabled" name="enabled" [checked]="checked" style="display: none;" aria-invalid="false">
    <div class="switch-handle"></div>
</span>